import { render, staticRenderFns } from "./ModalFormGroup.vue?vue&type=template&id=7705961b&scoped=true&"
import script from "./ModalFormGroup.vue?vue&type=script&lang=js&"
export * from "./ModalFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormGroup.vue?vue&type=style&index=0&id=7705961b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705961b",
  null
  
)

export default component.exports